import { Phone, MapPin, Mail } from "lucide-react";
import { WhatsAppIcon } from "./icons";
import { BUSINESS } from "@/lib/api";
import { trackConversion } from "@/lib/gtag";

export default function Footer() {
  return (
    <footer className="bg-steel-900 border-t border-steel-700 text-steel-300">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-display font-black text-2xl text-white tracking-tighter">SUDEEKSHA</div>
          <div className="font-label text-xs tracking-[0.35em] uppercase text-steel-400 mb-5">Invisible Grills · Hyderabad</div>
          <p className="max-w-sm leading-relaxed text-steel-400">
            Premium invisible grills that keep your family safe while preserving the view you fell in love with.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="font-label text-xs uppercase tracking-wider text-steel-500 mb-4">Contact</div>
          <a href={`tel:+91${BUSINESS.phone}`} onClick={trackConversion} className="flex items-center gap-2 mb-3 hover:text-white transition-colors"><Phone size={16} /> {BUSINESS.phoneDisplay}</a>
          <a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noreferrer" onClick={trackConversion} className="flex items-center gap-2 mb-3 hover:text-white transition-colors"><WhatsAppIcon size={16} className="text-[#25D366]" /> WhatsApp</a>
          <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 mb-3 hover:text-white transition-colors break-all"><Mail size={16} /> {BUSINESS.email}</a>
          <div className="flex items-center gap-2"><MapPin size={16} /> Hyderabad, Telangana</div>
        </div>
        <div className="md:col-span-4">
          <div className="font-label text-xs uppercase tracking-wider text-steel-500 mb-4">Areas we serve</div>
          <p className="leading-relaxed text-steel-400">Gachibowli · Kondapur · Madhapur · Hitech City · Kukatpally · Manikonda · Financial District & across Hyderabad.</p>
        </div>
      </div>
      <div className="border-t border-steel-800">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-steel-500">
          <span>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</span>
          <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-steel-300 transition-colors">Admin Login</a>
        </div>
      </div>
    </footer>
  );
}
